import React, { useEffect } from "react";
import {
  Navigate,
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
//===MUI IMPORTS===
import { Paper } from "@material-ui/core";

//===REDUX STORE IMPORTS===

//===COMPONENT IMPORTS===
import Footer from "./Footer/Footer";
import "./App.css";
import "./UI/Theme/ThemeColors.css";
import AppBar from "./AppBar/AppBar";
import Home from "./LandingPage/Home/Home";
import Dashboard from "./Dashboard/Dashboard";
import DashboardItem from "./Dashboard/MenuPanel/DashboardItem/DashboardItem";
import ActiveRentals from "./Dashboard/MenuPanel/ActiveRentals/ActiveRentals";
import AvailableRentals from "./Dashboard/MenuPanel/AvailableRentals/AvailableRentals";
import Transactions from "./Dashboard/MenuPanel/Transactions/Transactions";
import Users from "./Dashboard/MenuPanel/Users/Users";
import Settings from "./Dashboard/MenuPanel/Settings/Settings";
import PrivacyPolicy from "./PrivacyTerms/PrivacyPolicy/PrivacyPolicy";
import Terms from "./PrivacyTerms/Terms/Terms";

import NotFound from "../pages/NotFound";
import Page5 from "../pages/Player Dashboard/PlayerDashboard";
import Page6 from "../pages/Wallet Connect/WalletConnect";
import HomePage from "../pages/HomePage/Home";
import Page3 from "../pages/Sign-in/Sign-in";
import Page16 from "../pages/RentWearable/RentWearable";
import Page7 from "../pages/Owner Dashboard/OwnerDashboard";
import Page17 from "../pages/FAQs/FAQs";
import Dash from "../components/dashboardBar/DashboardBar";
import { useDispatch } from "react-redux";
import { Login } from "../store/Actions/AuthActions";
import { fetchAllTransactions } from "../store/Actions/TransactionsActions";
import LoginPage from "./LoginPage/Login";
export const AuthToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImYzODAxNzRlLTQ2NTUtNDU1MC04ZjZiLWM1NTY2YWEzMjNiZSIsImlhdCI6MTY0NTcxODI3MiwiZXhwIjoxNjQ1NzI1NDcyfQ.8wSblzkypOct4JGiqbThlX_qVdUmBYYn-_FPvJFG6uw";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(Login("0xE83cd74dA3133A63c5Cd233a1E6563c6C080E3ea"));
    dispatch(fetchAllTransactions(AuthToken));
  }, []);
  return (
    <Router>
      <Paper elevation={0} square>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
          <Route path="/terms-of-services" exact element={<Terms />} />
          <Route
            path="/dashboard"
            element={<Navigate to="/dashboard/admin" />}
          />
          <Route path="/dashboard/*" element={<Dashboard />}>
            <Route path="admin" element={<DashboardItem />} />
            <Route path="active-rentals" element={<ActiveRentals />} />
            <Route path="available-rentals" element={<ActiveRentals />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="users" element={<Users />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route exact path="/connect-wallet" element={<Page3 />} />
          <Route exact path="/player-dashboard" element={<Page5 />} />
          <Route exact path="/my-wearables" element={<Page6 />} />
          <Route exact path="/owner-dashboard" element={<Page7 />} />
          <Route exact path="/rent-wearable" element={<Page16 />} />
          <Route exact path="/faqs" element={<Page17 />} />
          <Route exact path="/dash" element={<Dash />} />
          <Route exact path="/login" element={<LoginPage />} />
          <Route exact path="*" element={<NotFound />} />
        </Routes>
      </Paper>
    </Router>
  );
};

export default App;

